<ion-app>
    <app-menu [ngClass]="{'hidden': (isScanRequired$ | async)}"></app-menu>
    <ion-router-outlet id="main-content" [ngClass]="{ 'hidden': (isScanRequired$ | async) }"></ion-router-outlet>
</ion-app>

<!-- Función para escanear QR. -->
<div *ngIf="isScanRequired$ | async" class="main_scan_content">
    <ion-button (click)="stopScan()" class="main_cancel_btn" shape="round" size="small">Cancelar</ion-button>
</div>